import { RightOutlined } from '@ant-design/icons';
import { Collapse as AntCollapse, Space } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import {
  LIVESTREAM_PLAYBACK_HOURS,
  LIVESTREAM_BROADCAST_HOURS,
  VIDEO_STORAGE_HOURS,
  VIDEO_PLAYBACK_HOURS,
  PEOPLE_CREDITS,
} from '@services/data-usage-service';

import { LEVEL_ERROR, LEVEL_INFO, LEVEL_WARN } from './constants';
import UsageLimitAlert from './UsageLimitAlert';
import UsageLimitDetails from './UsageLimitDetails';
import UsageLimitHeader from './UsageLimitHeader';

const Collapse = styled(AntCollapse)`
  && {
    background: white;
  }
  && .ant-collapse-header {
    align-items: center;
  }
`;

export const getLevel = (type, percent) => {
  if (percent < 80) {
    return LEVEL_INFO;
  }

  if (
    percent > 100 ||
    (percent === 100 && type === VIDEO_PLAYBACK_HOURS) ||
    (percent === 100 && type === PEOPLE_CREDITS)
  ) {
    return LEVEL_ERROR;
  }

  return LEVEL_WARN;
};

const UsageLimitCollapse = ({ type, used, limit, disabled = false, ...entity }) => {
  const percent = limit ? Math.round((used / limit) * 100) : 0;
  const level = getLevel(type, percent);

  return (
    <Collapse
      expandIconPlacement="end"
      expandIcon={({ isActive }) => (
        // wrap the icon in a div to align it horizontally with the header
        <div>
          <RightOutlined rotate={isActive ? 90 : 0} />
        </div>
      )}
      collapsible={disabled ? 'disabled' : undefined}
      items={[
        {
          key: type,
          label: (
            <UsageLimitHeader
              type={type}
              used={used}
              limit={limit}
              percent={percent}
              level={level}
              disabled={disabled}
              {...entity}
            />
          ),
          children: (
            <Space size="middle" orientation="vertical" style={{ width: '100%' }}>
              <UsageLimitAlert type={type} percent={percent} level={level} />
              <UsageLimitDetails type={type} entity={entity} />
            </Space>
          ),
        },
      ]}
    />
  );
};

UsageLimitCollapse.propTypes = {
  type: PropTypes.oneOf([
    LIVESTREAM_BROADCAST_HOURS,
    LIVESTREAM_PLAYBACK_HOURS,
    VIDEO_STORAGE_HOURS,
    VIDEO_PLAYBACK_HOURS,
    PEOPLE_CREDITS,
  ]).isRequired,
  used: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  entity: PropTypes.shape({}),
  disabled: PropTypes.bool,
};

export default UsageLimitCollapse;
